/**
 * FT8-U17: Credit Control (FSD 2.2.3 — Check Credit, Place on Credit Hold, credit limit
 * changes with before and after, Credit Exposure Report).
 *
 * A per-feature route file; the INT packet spreads `AR_CREDIT_CONTROL_ROUTES` into the
 * router and adds the nav item. `ar.credit.read` opens the screen; hold, release and
 * the limit request are gated inside it on their own route permissions.
 */

import type { RouteRecordRaw } from 'vue-router'

import { AR_CREDIT_PERMISSIONS } from '@/modules/ar/credit-control/permissions'

export const AR_CREDIT_CONTROL_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ar/credit-control',
    name: 'ar-credit-control',
    component: () => import('@/modules/ar/credit-control/CreditControlView.vue'),
    meta: { titleKey: 'ar.routeTitles.creditControl', permission: AR_CREDIT_PERMISSIONS.read },
  },
]
